import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// components (global)
import { CustomTabs } from "components/Tabs";

// components (local)
import { AuditTrailsTab, DetailsTab, TransactionTab } from "./components";

// material-ui
import { Close as CloseIcon } from "@material-ui/icons";
import { Button, Divider, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// stores
import { closeDrawer } from "stores/main/MainActions";
import { toggleEditResidentDialogOpen } from "stores/card/CardAction";

// styles
const useStyles = makeStyles((theme) => ({
  root: {},
  header: {
    paddingBottom: theme.spacing(1),
    flexShrink: 0,
    display: "flex",
  },
  content: { paddingTop: theme.spacing(1) },
  tabContent: { padding: theme.spacing(2) },
  listOdd: { backgroundColor: "#f9f9f9" },
  listTitle: { width: theme.spacing(5) },
}));

const ResidentCardDetails = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  // selector
  const cardId = useSelector((state) => state.main.toggleDrawer.parameterId);
  const card = useSelector((state) => {
    return state.firestore.data.resident_cards
      ? state.firestore.data.resident_cards[cardId]
      : null;
  });

  // state
  const [tabs] = useState([
    {
      value: "details",
      label: "Details",
      content: <DetailsTab />,
    },
    {
      value: "transactions",
      label: "Transactions",
      content: <TransactionTab />,
    },
    {
      value: "audit_trails",
      label: "Audit Trails",
      content: <AuditTrailsTab />,
    },
  ]);

  // functions
  const onClose = () => {
    dispatch(closeDrawer());
  };

  const handleEditCard = () => {
    dispatch(toggleEditResidentDialogOpen({ open: true, id: cardId }));
    onClose();
  };

  return (
    <div>
      <Grid container className={classes.header} justify="space-between">
        <Grid>
          <Button onClick={onClose} size="small">
            <CloseIcon className={classes.buttonIcon} />
            Close
          </Button>
        </Grid>
      </Grid>

      <Divider />

      <Grid
        direction="row"
        alignItems="flex-start"
        container
        justify="space-between"
        className={classes.content}
      >
        <Grid item>
          <Typography component="h1" variant="h3">
            {`${card.identity_number}`}
          </Typography>
        </Grid>
        {card.status !== "deleted" && (
          <Grid
            xs
            item
            alignItems="center"
            className={classes.header}
            container
            justify="flex-end"
            spacing={2}
          >
            <Grid item>
              {card.status !== "delete" && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleEditCard}
                >
                  Edit Card
                </Button>
              )}
            </Grid>
          </Grid>
        )}
      </Grid>

      <CustomTabs tabs={tabs} defaultTabIndex={0} />
    </div>
  );
};

export default ResidentCardDetails;
